<template>
    <div id="app" v-loading="$store.state.loading">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>

<style lang="scss">
$fa-font-path: '~font-awesome/fonts';
</style>

<style>
html,
body,
#app {
    height: 100%;
    min-height: 100%;
    font-size: 14px !important;
    overflow: hidden;
}

img {
    vertical-align: middle;
    max-width: 100%;
}
</style>
